export const APIKEYNUMBEROFTRIES = 20
export const APIKEYMSWAIT = 100
